import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "text"]

  generate(event) {
    const button = event.currentTarget
    const form = button.closest('form')
    
    // Disable button and show loading state
    button.disabled = true
    button.classList.add('opacity-50', 'cursor-not-allowed')
    
    // Show spinner if target exists
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }
    
    // Update button text if target exists
    if (this.hasTextTarget) {
      this.textTarget.textContent = 'Generating...'
    }
    
    // Submit the form
    form.submit()
  }
}

